/**
 * Remove duplicates from an array
 *
 * @typeparam T Type of the array (inferred)
 *
 * @param arr Array to remove duplicates from
 * @returns Array with duplicates removed
 */
export const uniqueArray = <T extends Array<any>>(arr: T) =>
	[...new Set(arr)] as T;
